// Copyright (c) 2025 by Audere

import {
  GetLabelsRequest,
  useGetLabelsQuery,
} from "../features/api/labelApiSlice";
import { useAppSelector } from "../features/store";
import { useCurrentUser } from "./useCurrentUser";

export const useLabels = (conversation_uid: string) => {
  const { isQC, group, isMonitor } = useCurrentUser();
  const labeler = useAppSelector((state) => state.label.labeler);

  const args: GetLabelsRequest = {
    group: group,
    conversation_uid,
    labeler_uid: isQC || isMonitor ? labeler?.labeler_uid : undefined,
    label_cursor: null,
    limit: 1000,
  };

  const {
    data: labels,
    isLoading,
    isFetching,
    refetch,
    error,
  } = useGetLabelsQuery(args, {
    skip: (isQC && !labeler?.labeler_uid) || isMonitor || !conversation_uid,
    refetchOnMountOrArgChange: false,
  });

  return { labels, isLoading, isFetching, refetch, error };
};
